// src/components/UmaiProductsSection.js
import React from 'react';
// Import Swiper React components
import { Swiper, SwiperSlide } from 'swiper/react';

// Import Swiper styles
import 'swiper/css';
import 'swiper/css/navigation';
// import 'swiper/css/pagination'; // Décommentez si vous voulez la pagination
import 'swiper/css/autoplay';

// import required modules
import { Navigation, A11y, Autoplay } from 'swiper/modules'; // Autoplay est inclus

import ProductCard from './ProductCard'; // Réutilise le composant ProductCard
import './UmaiProductsSection.css';   // Styles spécifiques pour cette section

// Données exemples pour les produits UMAI
const umaiProductsData = [
  // --- SOINS CAPILLAIRES UMAÏ ---
  {
    id: 'umaiShampoingDoux',
    name: "Shampoing Doux",
    description: "Concentré en huile et en beurre, il nourrit et laisse les cheveux doux, nourris et en bonne santé. Nettoie efficacement sans irriter le cuir chevelu.",
    imageSrc: "/images/doux.webp" // Image à ajouter dans public/images
  },
    {
    id: 'umaiShampoingViolet',
    name: "Shampoing Violet",
    description: "Ravive l'éclat des cheveux blonds, gris, blancs ou décolorés. Élimine les reflets jaunes indésirables, nourrit et renforce la fibre capillaire.",
    imageSrc: "/images/violet.webp" // Image à ajouter dans public/images
  },
  {
    id: 'umaiShampoingApresSoleil',
    name: "Shampoing Après-Soleil",
    description: "L'allié des cheveux exposés au sel, sable et chlore. Nettoie en douceur, élimine les résidus et rend les cheveux doux, brillants et nourris.",
    imageSrc: "/images/soleil.webp" // Image à ajouter dans public/images
  },
  {
    id: 'umaiApresShampoingDemelant',
    name: "Après-Shampoing Démêlant",
    description: "Préserve la fibre capillaire, scelle l'hydratation et apporte brillance. Sa texture lactée rend les cheveux instantanément doux et faciles à démêler.",
    imageSrc: "/images/demelant.webp" // Image à ajouter dans public/images
  },
  {
    id: 'umaiMasqueSoinBrillance',
    name: "Masque Soin Brillance",
    description: "Rend les cheveux plus lumineux, plus doux et lisse les cuticules. Idéal pour des cheveux doux et brillants toute l'année.",
    imageSrc: "/images/brillance.webp" // Image à ajouter dans public/images
  },
  {
    id: 'umaiCremeDefinitionBoucles',
    name: "Crème Définition Boucles",
    description: "Nourrit, hydrate et fixe les boucles pour un rendu naturel, souple et brillant. Contient un actif reminéralisant pour une meilleure tenue.",
    imageSrc: "/images/boucle.webp" // Image à ajouter dans public/images
  },
  // --- SOINS CORPS & VISAGE UMAÏ ---
  {
    id: 'umaiSoinLavantCorpsAmbreBoise',
    name: "Soin Lavant Corps Ambre Boisé",
    description: "Sans savon, procure une sensation unique d'hydratation, de douceur et de confort. Nettoie délicatement sans tiraillements, rougeurs ni irritations.",
    imageSrc: "/images/ambre.webp" // Image à ajouter dans public/images
  },
  {
    id: 'umaiSoinLavantCorpsVanillePoudree',
    name: "Soin Lavant Corps Vanille Poudrée",
    description: "Sans savon, ultra-doux, pour une hydratation et un confort après chaque douche. Nettoie sans irriter, même les peaux sensibles.",
    imageSrc: "/images/vanille.webp" // Image à ajouter dans public/images
  },
  {
    id: 'umaiExfoliantLissant',
    name: "Exfoliant Lissant",
    description: "Exfolie la peau en douceur, prévient le vieillissement cutané, restaure la fonction barrière et lisse les ridules.",
    imageSrc: "/images/lissant.webp" // Image à ajouter dans public/images
  },
  {
    id: 'umaiRoutineVisage',
    name: "Routine Visage",
    description: "Essentielle pour préparer la peau aux soins, éliminer les impuretés, stimuler le renouvellement cellulaire et obtenir une peau douce et éclatante.",
    imageSrc: "/images/routine.webp" // Image à ajouter dans public/images
  },
  {
    id: 'umaiSoinsPourLui',
    name: "Soins pour Lui",
    description: "Deux essentiels efficaces, naturels et sans savon pour nettoyer, apaiser et offrir un vrai moment de confort à la peau des hommes.",
    imageSrc: "/images/lui.webp" // Image à ajouter dans public/images
  },
  {
    id: 'umaiRoutineCorps',
    name: "Routine Corps",
    description: "Deux indispensables pour nettoyer, exfolier et tonifier la peau en douceur, pour un toucher lisse, doux et confortable au quotidien.",
    imageSrc: "/images/corps.webp" // Image à ajouter dans public/images
  },
];

function UmaiProductsSection() {
  return (
    <section id="umai-products" className="umai-products-section">
      <div className="container">
        <h2 className="section-title">Notre Sélection UMAI</h2>
        <p className="section-subtitle umai-intro">
          Chez Studio Ambre, nous avons à cœur de vous proposer des produits respectueux de vos cheveux et de la planète.
          Découvrez UMAI : des soins capillaires solides, naturels, zéro déchet et fabriqués en France, pour une beauté engagée et efficace.
        </p>

        {/* MODIFICATION: Remplacement de la grille par Swiper */}
        <Swiper
          modules={[Navigation, A11y, Autoplay]}
          spaceBetween={20} // Espace entre les slides
          slidesPerView={1} // Affichage par défaut pour mobile
          navigation // Active les flèches de navigation
          loop={true}
          autoplay={{
            delay: 4000, // Délai un peu plus long pour les produits
            disableOnInteraction: false,
            pauseOnMouseEnter: true,
          }}
          grabCursor={true}
          breakpoints={{
            // Pour tablettes
            640: { // Un breakpoint un peu plus tôt que 768 pour 2 slides
              slidesPerView: 2,
              spaceBetween: 25,
            },
            // Pour ordinateurs portables / petits écrans de bureau
            1024: {
              slidesPerView: 3,
              spaceBetween: 30,
            },
            // Pour écrans de bureau plus larges
            1200: {
              slidesPerView: 4,
              spaceBetween: 30,
            }
          }}
          className="umai-swiper-container" // Classe pour le style spécifique
        >
          {umaiProductsData.map(product => (
            <SwiperSlide key={product.id}>
              <ProductCard
                name={product.name}
                description={product.description}
                imageSrc={product.imageSrc}
                // subInfo={product.subInfo}
              />
            </SwiperSlide>
          ))}
        </Swiper>

        <p className="umai-availability-note">
          Retrouvez ces produits et bien d'autres conseils personnalisés directement au salon Studio Ambre.
        </p>
      </div>
    </section>
  );
}

export default UmaiProductsSection;